import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AlertsListFilter } from '@pages/alerts/alerts-list/model/alerts-list.filter';
import { Alert } from '@core/domain/model/alerts/alert.model';
import { SortEvent } from '@shared/components/table/sort/model/sort.model';

export const alertsActions = createActionGroup({
  source: 'ALERTS',
  events: {
    fetchAlerts: emptyProps(),
    filterAlerts: props<{ filter: AlertsListFilter }>(),
    setAlerts: props<{ data: Alert[] }>(),
    errorAlerts: props<{ error: string }>(),
    sortAlerts: props<{ sort: SortEvent }>(),
    deleteAlert: props<{ alert: Alert }>(),
  },
});
